module.exports = __webpack_public_path__ + "static/media/Frida.35e5d7b3.usdz";